export type JobsHubMode = 'find' | 'hire'

/**
 * Top toggle on the Jobs tab: seek jobs (CV + listings) vs hire
 * (post a job, applicants, company details). Shared so deep links and
 * the + sheet can open the Hire side without a second bottom-nav tab.
 */
export function useJobsHubMode() {
  const mode = useState<JobsHubMode>('jobs-hub-mode', () => 'find')
  const pendingMode = useState<JobsHubMode | null>('jobs-hub-pending-mode', () => null)

  function requestMode(next: JobsHubMode) {
    pendingMode.value = next
    mode.value = next
  }

  function consumePendingMode(): JobsHubMode | null {
    const next = pendingMode.value
    pendingMode.value = null
    return next
  }

  async function goToHire() {
    const { account } = useProfileAccount()
    const { PROVIDER_ROUTES, SEEKER_ROUTES } = useAppNavigation()
    requestMode('hire')
    if (account.value === 'hiring_agent') {
      return navigateTo(PROVIDER_ROUTES.publish)
    }
    return navigateTo(SEEKER_ROUTES.cv)
  }

  async function goToFind() {
    const { SEEKER_ROUTES } = useAppNavigation()
    requestMode('find')
    return navigateTo(SEEKER_ROUTES.cv)
  }

  return { mode, requestMode, consumePendingMode, goToHire, goToFind }
}
